<template>
  <div class="button-multiple-actions" v-if="isOpen" @click="close()">
    <div class="__modal" :style="{ 'top' : (position.top + position.height / 2) + 'px', 'left': (position.left + position.width / 2) + 'px' }" @click.stop>
      <div class="__header">
        <div class="__title">{{ $t('ct-multiple-actions') }}</div>
        <div class="__close" @click="close()">
          <font-awesome-icon
            class="font-awesome-icon"
            :icon="['fas', 'times']"
          />
        </div>
      </div>
      <div class="__actions-list">
         <div class="form-group form-check" style="padding-left: 30px; padding-top: 15px">
          <input type="checkbox" class="form-check-input" :checked="isRotator" @change="applyRotator" id="checkBoxRotator">
          <label class="form-check-label" for="exampleCheck1">{{ $t('ct-link-rotator') }} </label>
        </div>
        <div class="__action-item" v-for="a in actions" :key="a.id">
          <div class="__number">
            <input type="number" min="1" v-model="a.limit" @change="apply()" />
          </div>
          <div class="__name">
            <input type="text" v-model="a.name" @change="apply()" />
          </div>
          <div class="__options">
            <div class="__edit" @click="edit(a)">
              <font-awesome-icon
                class="font-awesome-icon"
                :icon="['fas', 'pen']"
              />
            </div>
            <div class="__remove" @click="remove(a)">
              <font-awesome-icon
                class="font-awesome-icon"
                :icon="['fas', 'trash']"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="__footer">
        <div class="__add" @click="add()">
          <font-awesome-icon
            class="font-awesome-icon"
            :icon="['fas', 'plus']"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonMultipleActions",
  data() {
    return {
      actions: [],
      callback: () => {},
      isOpen: false,
      isRotator: false,
    };
  },
  computed: {
    modalStyle() {
      const { top, left, height, width } = this.position;
      return {
        top: `${top + height / 2}px`,
        left: `${left + width / 2}px`,
      };
    },
  },
  methods: {
    open(event, data, callback) {
      console.log(data);
      this.position = event.target.getBoundingClientRect();
      this.actions = data.actions;
      this.isRotator = data.rotator;
      this.callback = callback;
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
      this.apply();
    },
    edit({ id, name, link, limit }) {
      this.$root.$emit(
        "linkComponentShow",
        { internal_config: { link } },
        null,
        (_link) => {
          this.actions = [
            ...this.actions.filter((a) => a.id != id),
            { id, name, limit, link: _link },
          ];
          this.apply();
        }
      );
    },
    add() {
      this.actions.push({
        id: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(36),
        name: "My action",
        limit: 10000,
        link: {
          type: "web",
          value: "",
          valueID: "",
          target: "_blank",
          tel: "",
          telSelectedMask: "",
          telOpenAs: "",
        },
      });
      this.apply();
    },
    remove({ id }) {
      this.actions = this.actions.filter((a) => a.id != id);
      this.apply();
    },
    applyRotator() {
      this.isRotator = !this.isRotator;
      this.apply();
    },
    apply() {
      for(let i = 0; i < this.actions.length; i++){
          if(this.actions[i].limit < 1) { this.actions[i].limit = 1; }
          if(this.actions[i].name === '') { this.actions[i].name = 'My action'; }
      }
      this.callback(this.actions.sort((a, b) => a.limit - b.limit), this.isRotator);
    },
  },
};
</script>

<style lang="sass" scoped>
.button-multiple-actions
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background: rgba(#000, 0.1)
  .__modal
    position: absolute
    // left: 50%
    // top: 50%
    width: 300px
    display: flex
    flex-direction: column
    background: #fff
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)
    border-radius: 6px
    color: #555
    overflow: hidden
    font-size: .9rem
    .__header
      padding: .5rem 1rem
      background-color: #1C80FC
      border-bottom: 1px solid darken(whitesmoke, 10%)
      color: white
      display: flex
      align-items: center
      .__title
        flex: 1
      .__close
        transform: scale(0.6)
    .__actions-list
      overflow-y: auto
      min-height: 200px
      max-height: 200px
      &::-webkit-scrollbar
        width: 6px
      &::-webkit-scrollbar-track
        background: #fff
      &::-webkit-scrollbar-thumb
        background: darken(whitesmoke, 5%)
        border-radius: 6px
      &::-webkit-scrollbar-thumb:hover
        background: darken(whitesmoke, 10%)
      .__action-item
        display: flex
        align-items: center
        flex: 1
        padding: .5rem 1rem
        .__number
          width: 20%
          input
            width: 100%
            min-width: 0
            border: 0
            padding: 0
            outline: none !important
            color: #555
            height: auto
        .__name
          width: 50%
          input
            width: 100%
            min-width: 0
            border: 0
            padding: 0
            outline: none !important
            color: #555
            height: auto
        .__options
          width: 30%
          display: flex
          justify-content: flex-end
          .__edit, .__remove
            svg
              transform: scale(0.5)
          .__remove
            color: #ff6b6b
    .__footer
      padding: .5rem 1rem 1rem 1rem
      .__add
        background: whitesmoke
        border-radius: 6px
        padding: .25rem
        display: flex
        align-items: center
        justify-content: center
        cursor: pointer
        transition: background 250ms
        &:hover
          background: darken(whitesmoke, 5%)
        .font-awesome-icon
          transform: scale(0.5)
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/ButtonMultipleActions.vue